/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import logger from './logger';
import vuetify from './vuetify'
import router from '../router'
import store from '@/store'
import { createHead } from '@unhead/vue'
import { createGtag } from "vue-gtag";
import Vue3VideoPlayer from '@cloudgeek/vue3-video-player'
import '@cloudgeek/vue3-video-player/dist/vue3-video-player.css'

console.log('logger',logger);

const env = import.meta.env;

const gtag = createGtag(  {
    tagId: env.VITE_GOOGLE_ANALYTICS_ID,
    appName: env.VITE_APP_NAME,
    initMode: 'auto',
    pageTracker: {
      router,
      useScreenview: true,
      sendPageView: true,
    },
    hooks: {
      "script:loaded": () => {
        console.log("script GTAG loaded");
      },
      "script:error": () => {
        console.log("script GTAG error");
      }
    }
});

const head = createHead()
console.log("createHead",head);

export function registerPlugins (app) {
  app
    .use(vuetify)
    .use(store)
    .use(head)
    .use(router)
    .use(gtag)
    app.use(Vue3VideoPlayer, {
      lang: 'en'
    })
}
